module.exports = __webpack_public_path__ + "static/img/book17.d39fd4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book17.jpg
// module id = 8cz9
// module chunks = 1